import { useMutation } from '@tanstack/react-query';
import { TEN_SECONDS, TOAST_ERROR, showToast } from 'lib/utils';

import { makeOpenRollfiPayroll } from 'main/factories/usecases/rollfi';
import { useParams } from 'react-router-dom';

export const useOpenRollfiPayroll = () => {
  const { locationId: currentLocationId } = useParams();

  return useMutation({
    mutationFn: () => {
      const service = makeOpenRollfiPayroll();
      return service.openRollfiPayroll({ locationId: String(currentLocationId) });
    },
    onError: () => {
      showToast('Error while opening Rollfi Payroll', TOAST_ERROR, TEN_SECONDS);
    },
    onSuccess: data => {
      if (data && typeof data === 'string') {
        window.open(data, '_blank');
      } else {
        showToast('Failed to get payroll SSO URL', TOAST_ERROR, TEN_SECONDS);
      }
    },
  });
};
